import type { IndexRecord, RedirectMap } from "../../shared/snapshot-format";
import { loadCatalogue } from "./catalogue";
import { loadRedirects } from "./entries";

/** What an `@UUID` link can find out synchronously once the catalogue and redirects are in memory. */
export interface LinkResolver {
  /** The current UUID and its catalogue record when the target ships in this Snapshot; null otherwise. */
  resolve(uuid: string): IndexRecord | null;
  /** An action Entry by slug (`[[/act seek]]`), null when none ships. */
  action(slug: string): IndexRecord | null;
}

export function createLinkResolver(records: IndexRecord[], redirects: RedirectMap): LinkResolver {
  const byUuid = new Map(records.map((r) => [r.u, r]));
  const actions = new Map(records.filter((r) => r.t === "action" && r.p === "actionspf2e").map((r) => [r.s, r]));
  return {
    resolve(uuid) {
      let cur = uuid;
      for (let i = 0; i < 8 && redirects[cur]; i++) cur = redirects[cur]!;
      return byUuid.get(cur) ?? null;
    },
    action(slug) {
      return actions.get(slug) ?? null;
    },
  };
}

let cached: Promise<LinkResolver> | undefined;

/** The resolver over the shipped catalogue and redirects; loaded once per page load. */
export function loadLinkResolver(): Promise<LinkResolver> {
  cached ??= Promise.all([loadCatalogue(), loadRedirects()]).then(([records, redirects]) => createLinkResolver(records, redirects));
  return cached;
}
